<template>
  <DsShowcase title="InputPlayV3" description="Input com suporte a ícones, máscara, estados de erro e tamanhos consistentes com o ButtonPlayV2.">
    <!-- PROP: size -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">size</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>'sm' | 'md' | 'lg'</code> — padrão: <code>md</code></p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 v-model="v1" placeholder="Small" size="sm" />
        <InputPlayV3 v-model="v2" placeholder="Medium (padrão)" size="md" />
        <InputPlayV3 v-model="v3" placeholder="Large" size="lg" />
      </div>
    </section>

    <!-- PROP: icon / rightIcon -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">icon / rightIcon</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — ícone Material Symbols à esquerda ou direita</p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 v-model="v4" placeholder="Buscar..." icon="search" />
        <InputPlayV3 v-model="v5" placeholder="Email" icon="mail" right-icon="check_circle" />
        <InputPlayV3 v-model="v6" placeholder="Senha" right-icon="visibility" :right-icon-clickable="true" type="password" />
      </div>
    </section>

    <!-- PROP: iconClickable / rightIconClickable -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">iconClickable / rightIconClickable</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — torna o ícone clicável (emite <code>@iconClick</code> / <code>@rightIconClick</code>)</p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 v-model="v7" placeholder="Clique no X para limpar" right-icon="close" :right-icon-clickable="true" @right-icon-click="v7 = ''" />
      </div>
    </section>

    <!-- PROP: error -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">error</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — ativa estado de erro (borda vermelha)</p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 v-model="v8" placeholder="Campo com erro" :error="true" icon="error" />
      </div>
    </section>

    <!-- PROP: disabled / readonly -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled / readonly</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 model-value="Campo desabilitado" :disabled="true" />
        <InputPlayV3 model-value="Campo somente leitura" :readonly="true" />
      </div>
    </section>

    <!-- PROP: type -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">type</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — tipo HTML do input. Padrão: <code>text</code></p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 v-model="v9" placeholder="Texto" type="text" />
        <InputPlayV3 v-model="v10" placeholder="Número" type="number" />
        <InputPlayV3 v-model="v11" placeholder="Senha" type="password" right-icon="visibility_off" />
      </div>
    </section>

    <!-- PROP: mask -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">mask</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string | string[]</code> — máscara de input (via maska)</p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 v-model="v12" placeholder="CPF: 000.000.000-00" mask="###.###.###-##" />
        <InputPlayV3 v-model="v13" placeholder="Telefone" :mask="['(##) ####-####', '(##) #####-####']" />
      </div>
    </section>

    <!-- PROP: skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:flex tw:flex-col tw:gap-4 tw:max-w-lg">
        <InputPlayV3 :skeleton="true" />
        <InputPlayV3 :skeleton="true" size="lg" />
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { InputPlayV3 } from "@/components/atomic"

const v1 = ref('')
const v2 = ref('')
const v3 = ref('')
const v4 = ref('')
const v5 = ref('')
const v6 = ref('')
const v7 = ref('Texto para limpar')
const v8 = ref('')
const v9 = ref('')
const v10 = ref('')
const v11 = ref('')
const v12 = ref('')
const v13 = ref('')
</script>
